import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { inr, walletTotal } from "../../utils/format";
import Navbar from "./Navbar";
import "../../styles/pages.css";

const TABS = [
  { to: "/", label: "Home", d: "M3 11l9-8 9 8v9a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z" },
  { to: "/game", label: "Play", d: "M5 3l14 9-14 9z" },
  { to: "/my-bets", label: "Bets", d: "M4 5h16v3H4zM4 11h16v3H4zM4 17h10v3H4z" },
  { to: "/deposit", label: "Wallet", d: "M3 7h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM3 7l2-3h12v3M16 13h3" },
  { to: "/profile", label: "Profile", d: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 21a8 8 0 0 1 16 0z" },
];

export default function PageShell({ title, children, back = true }) {
  const navigate = useNavigate();
  const { user, wallet, logout } = useAuth();

  const menuItems = [
    { label: `Signed in: ${user?.username || "Player"}`, onClick: () => navigate("/") },
    { label: "Play Game", onClick: () => navigate("/game") },
    { label: "My Profile", onClick: () => navigate("/profile") },
    { label: "Bet History", onClick: () => navigate("/my-bets") },
    { label: "Results", onClick: () => navigate("/results") },
    { label: "Deposit", onClick: () => navigate("/deposit") },
    { label: "Withdraw", onClick: () => navigate("/withdraw") },
    { label: "Logout", onClick: () => { logout(); navigate("/login", { replace: true }); } },
  ];

  return (
    <>
      <Navbar menuItems={menuItems} balance={wallet ? inr(walletTotal(wallet)) : null} />
      <div className="pg">
        <div className="pg-title">
          {back && <button className="pg-back" onClick={() => navigate("/game")}>Back to game</button>}
          <h1>{title}</h1>
        </div>
        <main className="pg-body">{children}</main>
      </div>
      <nav className="bnav" aria-label="Main">
        {TABS.map((t) => (
          <NavLink key={t.to} to={t.to} end className={({ isActive }) => "bnav-i" + (isActive ? " on" : "")}>
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d={t.d} /></svg>
            <span>{t.label}</span>
          </NavLink>
        ))}
      </nav>
    </>
  );
}